import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import Loader from "react-loader-advanced";

import NormalTextField from "../common/NormalTextField";
import NormalBigButton from "../common/NormalBigButton";
import ActionButton from "../common/ActionButton";
import Config from "../../config";
import { createRequestOptions } from "../../services/utils";
import { Mixpanel } from "../../mixpanel";
import DatePicker from "material-ui/DatePicker";
import CalIcon from "material-ui/svg-icons/action/date-range";

import colors from "../../styles/colors";

const style = {
  container: {
    display: "flex",
    flexFlow: "column",
  },
  buttons: {
    display: "flex",
    flexFlow: "row",
  },
};

class EmailSender extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
      firstName: "",
      lastName: "",
      reasonForTreatment: "",
      estimatedTreatments: 10,
      isLibraryOnly: props.isLibraryOnly,
      text: this.props.note
        ? this.props.note
        : "Welcome! This app is going to help you do your exercises at home between appointments. Please follow the instructions — it takes 3 minutes — so you’ll be all set to go!",
    };

    this.send = this.send.bind(this);
  }

  send() {
    this.setState({ isLoading: true });

    const options = createRequestOptions({
      userId: this.props.userId,
      appId: this.props.appId,
      email: this.state.email,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      reasonForTreatment: this.state.reasonForTreatment,
      estimatedTreatments: this.state.estimatedTreatments
        ? this.state.estimatedTreatments
        : 0,
      dateOfEval: this.state.dateOfEval ? this.state.dateOfEval : null,
      patientGoal: this.state.patientGoal ? this.state.patientGoal : null,
      patientPhone: this.state.patientPhoneNumber
        ? this.state.patientPhoneNumber
        : null,
      text: "You are invited to use this Channel! Please follow the instructions to access it.",
    });

    fetch(Config.serverUrl + "/InviteUserToApp", options)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        Mixpanel.track("Invite user", {
          Email: this.state.email,
          "Channel Name": this.props.appName,
          Platform: "Web",
        });
        this.setState({ isLoading: false });
      })
      .catch((error) => {
        console.error("Error sending invite user email: " + error);
      });
  }

  validateEmail(email) {
    if (_.isEmpty(email)) {
      return "Email address is required";
    }

    const emailRegex = /^[a-zA-Z0-9\+._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (emailRegex.test(String(email).toLowerCase())) {
      //valid email address
      return "";
    } else {
      return "Invalid email address";
    }
  }

  render() {
    return (
      <div>
        <Loader show={this.state.isLoading} message={"Sending email..."}>
          <NormalTextField
            floatingLabelText="Email"
            fullWidth={true}
            errorText={this.validateEmail(this.state.email)}
            value={this.state.email}
            onChange={(event) => {
              this.setState({ email: event.target.value });
            }}
            whiteLabelSettings={this.props.whiteLabelSettings}
          />
          <NormalTextField
            floatingLabelText="First Name"
            fullWidth={true}
            errorText={
              _.isEmpty(this.state.firstName) ? "First Name is required" : ""
            }
            value={this.state.firstName}
            onChange={(event) => {
              this.setState({ firstName: event.target.value });
            }}
            whiteLabelSettings={this.props.whiteLabelSettings}
          />
          <NormalTextField
            floatingLabelText="Last Name"
            fullWidth={true}
            errorText={
              _.isEmpty(this.state.lastName) ? "Last Name is required" : ""
            }
            value={this.state.lastName}
            onChange={(event) => {
              this.setState({ lastName: event.target.value });
            }}
            whiteLabelSettings={this.props.whiteLabelSettings}
          />
          {!this.state.isLibraryOnly && (
            <NormalTextField
              floatingLabelText="Reason For Treatment"
              fullWidth={true}
              value={this.state.reasonForTreatment}
              onChange={(event) => {
                this.setState({ reasonForTreatment: event.target.value });
              }}
              whiteLabelSettings={this.props.whiteLabelSettings}
            />
          )}
          {!this.state.isLibraryOnly && (
            <NormalTextField
              floatingLabelText="Estimated Number Of Treatments"
              fullWidth={true}
              value={this.state.estimatedTreatments}
              onChange={(event) => {
                const onlyNums = event.target.value.replace(/[^0-9]/g, "");
                this.setState({ estimatedTreatments: onlyNums });
              }}
              whiteLabelSettings={this.props.whiteLabelSettings}
            />
          )}
          <div
            style={{ marginTop: 15, marginBottom: 15, color: colors.primary }}
          >
            Required For RTM Tracking (Medicare/RTM Only)
            <hr />
          </div>
          {!this.state.isLibraryOnly && (
            <div>
              <div
                style={{
                  fontSize: 16,
                  color: colors.tipGrey,
                  padding: 2,
                  position: "relative",
                  left: 0,
                  top: 0,
                  zIndex: 99,
                }}
              >
                Date Of Evaluation
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <DatePicker
                  label="Date Of Evaluation"
                  defaultDate={this.state.dateOfEval}
                  maxDate={new Date()}
                  onChange={(event, date) => {
                    this.setState({ dateOfEval: date });
                  }}
                  hideCalendarDate={true}
                  style={{
                    maxWidth: "100%",
                    fontSize: 16,
                    fontWeight: 600,
                    height: 35,
                    width: 900,
                  }}
                />
                <CalIcon />
              </div>
            </div>
          )}
          {!this.state.isLibraryOnly && (
            <NormalTextField
              floatingLabelText="Patient Phone Number"
              fullWidth={true}
              value={this.state.patientPhoneNumber}
              onChange={(event) => {
                this.setState({ patientPhoneNumber: event.target.value });
              }}
              whiteLabelSettings={this.props.whiteLabelSettings}
            />
          )}
          {!this.state.isLibraryOnly && (
            <NormalTextField
              floatingLabelText="Patient Goal"
              fullWidth={true}
              value={this.state.patientGoal}
              onChange={(event) => {
                this.setState({ patientGoal: event.target.value });
              }}
              whiteLabelSettings={this.props.whiteLabelSettings}
            />
          )}
          <div style={style.buttons}>
            <NormalBigButton
              label="Cancel"
              onClick={() => this.props.onClose()}
            />
            <ActionButton
              label="Send"
              disabled={
                _.isEmpty(this.state.email) ||
                this.validateEmail(this.state.email) ||
                _.isEmpty(this.state.firstName) ||
                _.isEmpty(this.state.lastName)
              }
              onClick={() => {
                this.send();
                this.props.onComplete();
              }}
              whiteLabelSettings={this.props.whiteLabelSettings}
            />
          </div>
        </Loader>
      </div>
    );
  }
}

EmailSender.propTypes = {
  userId: PropTypes.number.isRequired,
  appId: PropTypes.number.isRequired,
  sender: PropTypes.string,
  note: PropTypes.string,
  onComplete: PropTypes.func,
};

export default EmailSender;



// WEBPACK FOOTER //
// ./src/components/common/InviteUser.js